export const BudgetForm = 'BudgetForm';
export const ContactForm = 'ContactForm';
export const CreditCertificateForm = 'CreditCertificateForm';
export const CustomerForm = 'CustomerForm'; export const CustomFieldForm = 'CustomFieldForm';
export const CustomFormForm = 'CustomFormForm';
export const CustomTabForm = 'CustomTabForm';
export const DeviceForm = 'DeviceForm';
export const EmailForm = 'EmailForm';
export const EmailTransactionForm = 'EmailTransactionForm';
export const EmployeeForm = 'EmployeeForm';
export const EreceiptForm = 'EreceiptForm';
export const IntegrationFormName = 'IntegrationForm';
export const InventoryAdjustmentForm = 'InventoryAdjustmentForm';
export const InventoryReturnForm = 'InventoryReturnForm';
export const InventoryStocktakeForm = 'InventoryStocktakeForm';
export const InventoryStocktakeFormLinesFilter = 'InventoryStocktakeFormLinesFilter';
export const InventoryTransferForm = 'InventoryTransferForm';
export const ItemAddForm = 'ItemAddForm';
export const ItemGroupPriceForm = 'ItemGroupPriceForm';
export const ItemLocationFilter = 'ItemLocationFilter';
export const ItemLocationForm = 'ItemLocationForm';
export const ItemMatrixAttributeForm = 'ItemMatrixAttributeForm';
export const ItemUomForm = 'ItemUomForm';
export const ListForm = 'ListForm';
export const LocationForm = 'LocationForm';
export const MatrixChildDetailForm = 'MatrixChildDetailForm';
export const OrderManagementLineItemDeliveryAddressForm = 'OrderManagementLineItemDeliveryAddressForm';
export const OrderManagementLineItemShippingDetailsForm = 'OrderManagementLineItemShippingDetailsForm';
export const PaymentTransactionForm = 'PaymentTransactionForm';
export const PreferenceFilterForm = 'PreferenceFilterForm';
export const PreferenceForm = 'PreferenceForm';
export const PriceBookForm = 'PriceBookForm';
export const PromotionForm = 'PromotionForm';
export const PurchaseOrderForm = 'PurchaseOrderForm';
export const PurchaseReceiptForm = 'PurchaseReceiptForm';
export const SaleTransactionForm = 'SaleTransactionForm';
export const ShortcutFormName = 'ShortcutForm';
export const ShortcutGroupFormName = 'ShortcutGroupForm';
export const SmsForm = 'SmsForm';
export const StoreSummaryForm = 'StoreSummaryForm';
export const SubsidiaryForm = 'SubsidiaryForm';
export const SupplierForm = 'SupplierForm';
